import { useCurrentUser } from '@qualio/ui-components';
import { Parser } from 'html-to-react';
import { useEffect, useState } from 'react';
import {
  extractAttachmentIdFromHref,
  getBookmarkTarget,
  scrollToBookmarkTarget,
} from '../../../util/HTMLElementUtils';
import { DocumentLayout } from '../DocumentLayout/DocumentLayout';
import { InlineAttachmentPreviewModal } from '../InlineAttachmentPreview/InlineAttachmentPreviewModal';

interface DocumentCompareVersionsViewerProps {
  htmlContent: string;
  isLandscape?: boolean;
}

export const DocumentCompareVersionsViewer = ({
  htmlContent,
  isLandscape,
}: DocumentCompareVersionsViewerProps) => {
  const currentUser = useCurrentUser();
  const [attachmentForPreview, setAttachmentForPreview] = useState<string>();
  const [contentElement, setContentElement] = useState<Element | null>();

  useEffect(() => {
    setContentElement(document.querySelector('#documentHTMLViewerContent'));
    if (contentElement) {
      const anchors = contentElement.getElementsByTagName('a');
      for (const anchor of anchors) {
        anchor.addEventListener('click', (evt) => {
          evt.preventDefault();
          const href = (evt.currentTarget as any).href;
          if (!href) {
            return;
          }
          const attachmentId = extractAttachmentIdFromHref(href);
          if (attachmentId) {
            // open preview modal for links on inline attachments
            setAttachmentForPreview(attachmentId);
            return;
          }

          const bookmarkTarget = getBookmarkTarget(href);
          if (bookmarkTarget) {
            scrollToBookmarkTarget(bookmarkTarget);
            return;
          }

          // open links that are not inline attachments in a new tab
          window.open(href, '_blank');
        });
      }
    }
  }, [contentElement]);

  const htmlToReactParser = new Parser();

  const content = (
    <>
      {htmlToReactParser.parse(htmlContent)}
      {attachmentForPreview && (
        <InlineAttachmentPreviewModal
          currentUser={currentUser}
          attachmentId={attachmentForPreview}
          onClose={() => setAttachmentForPreview(undefined)}
        />
      )}
    </>
  );

  return (
    <DocumentLayout
      sections={[]} //showToc is off here so we dont actually care about these sections
      showTOC={false}
      showComments={false}
      contentId="documentHTMLViewerContent"
      dataCy={{
        content: 'documentHTMLViewerContent',
      }}
      isLandscape={isLandscape}
    >
      {content}
    </DocumentLayout>
  );
};
